import sanityClient from "@sanity/client";

export default sanityClient({ projectId: "7x2ekbvz", dataset: "production" });
